import apiClient from "../core/apiClient";
import { BellCountResponse, NotificationItem } from "../interfaces/DTO/notification";

const API_URL = "/notifications";

class NotificationService {
  async getBellCount(): Promise<number> {
    const response = await apiClient.get<BellCountResponse>(`${API_URL}/bell/count`);
    return response.data.count;
  }

  async getBellItems(): Promise<NotificationItem[]> {
    const response = await apiClient.get<NotificationItem[]>(`${API_URL}/bell/items`);
    return response.data;
  }

  async markSeen(notificationId: number): Promise<void> {
    await apiClient.post(`${API_URL}/bell/mark-seen/${notificationId}`);
  }
}

export const notificationService = new NotificationService();
